import React from 'react'
import DialogComponent from '../../DialogComponent/DialogComponent'
import { RegisterStudentRequest } from '../../../services/api-requests/api-request'
import { useSnackbarComponent } from '../../SnackbarComponents/useSnackbarComponent'
import {
  Button,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'

interface ICustomAuthInput {
  fieldName: string
  isRequired: boolean
}

const AuthExtrafieldsDialogComponent = (props: {
  title?: string
  openDialog: boolean
  setOpenDialog: (open: boolean) => void
  schoolDetails: any
  email: string
  registerWith: string
  registerToken: string
  setLoading: (loading: boolean) => void
  submitLoading: boolean
  RegisterSuccessful: (userData: any) => void
}) => {
  const [name, setName] = React.useState('')
  const [userCustomInputAnswer, setUserCustomInputAnswer] = React.useState<any>(
    {},
  )

  const snackbarHook = useSnackbarComponent()

  const aCustomAuthFieldsIsEmpty = () => {
    let result = false
    props.schoolDetails?.custom_auth_input?.map((item: ICustomAuthInput) => {
      const custom_inputs = userCustomInputAnswer?.[item?.fieldName]
      if (!custom_inputs?.trim?.() && item.isRequired) {
        result = true
      }
    })

    return result
  }

  const shouldEnableSubmit = () => {
    if (!name || !props.email || aCustomAuthFieldsIsEmpty()) {
      snackbarHook.open('!Please fill all required field', 'error')
      return false
    }
    return true
  }

  const submitData = (e: React.MouseEvent<{}>) => {
    e.preventDefault()

    if (!shouldEnableSubmit()) {
      return
    }

    props.setLoading?.(true)

    const RegisterPromise = RegisterStudentRequest({
      name,
      email: props.email,
      schoolId: props.schoolDetails._id,
      schoolNo: props.schoolDetails.school_no,
      customAuthInput: userCustomInputAnswer,
      registerWith: props.registerWith,
      registerToken: props.registerToken,
      ignorePasswordValidation: true,
    })

    RegisterPromise.then((response: any) => {
      console.log(response)
      const data = response.data
      if (data.data) {
        props.RegisterSuccessful(data.data)
        snackbarHook.open('Registration successful', 'success')
      }
    }).catch(err => {
      console.log('error registering students', err)
      props.setLoading?.(false)

      snackbarHook.open(err.response.data.message, 'error')
    })
  }

  const handleCustomAuthFieldChange = (key: string, value: string) => {
    const user_custom_field: any = userCustomInputAnswer
    user_custom_field[key] = value
    setUserCustomInputAnswer(user_custom_field)
  }

  const handleNameChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    setName(e.currentTarget.value)
  }

  return (
    <DialogComponent
      title={props.title || 'Complete Registration'}
      hideTitleBar={true}
      fullScreen={false}
      fullWidth={true}
      open={props.openDialog}
      contentStyle={{ backgroundColor: '#fafafa' }}
      disableBackgroundClickClose={true}
      content={
        <>
          {props.schoolDetails && (
            <div style={{ display: 'flex', padding: '5px' }}>
              <div style={{ marginBottom: '10px' }}>
                {props.schoolDetails.logo && (
                  <img
                    src={props.schoolDetails.logo}
                    style={{
                      height: '50px',
                      marginBottom: '6px',
                    }}
                  />
                )}
                <Typography
                  style={{ fontWeight: 500 }}
                  gutterBottom={true}
                  variant={'h5'}
                >
                  One last step
                </Typography>
                <Typography
                  style={{ fontWeight: 'bold', margin: '5px 0' }}
                  variant={'body2'}
                >
                  Complete the fields to finish student registration
                </Typography>
                <div style={{ marginBottom: '20px' }}>
                  <TextField
                    name={'email'}
                    type={'email'}
                    value={props.email}
                    color="primary"
                    required={true}
                    fullWidth={true}
                    variant="outlined"
                    label="Email"
                    disabled={true}
                    style={{ margin: '5px 0' }}
                  />
                  <TextField
                    name={'name'}
                    color="primary"
                    fullWidth={true}
                    variant="outlined"
                    required={true}
                    label="Name"
                    onChange={handleNameChange}
                    placeholder={"What's your name"}
                    // helperText={"Name is required"}
                    style={{ margin: '5px 0' }}
                  />
                  {props.schoolDetails.custom_auth_input?.map(
                    (item: ICustomAuthInput, index: number) => {
                      const key = item.fieldName
                      return (
                        <React.Fragment key={index}>
                          <TextField
                            name={key ? key.toLowerCase() : ''}
                            color="primary"
                            fullWidth={true}
                            required={item.isRequired}
                            variant="outlined"
                            label={key}
                            onChange={e => {
                              handleCustomAuthFieldChange(
                                key,
                                e.currentTarget.value,
                              )
                            }}
                            style={{ margin: '5px 0' }}
                          />
                        </React.Fragment>
                      )
                    },
                  )}
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={submitData}
                    fullWidth={true}
                    style={{ margin: '5px 0' }}
                  >
                    Register
                    {props.submitLoading && <CircularProgress size={20} />}
                  </Button>
                </div>
              </div>
              <IconButton
                style={{ position: 'absolute', top: '10px', right: '10px' }}
                size="large"
              >
                <Close
                  onClick={e => {
                    e?.preventDefault()
                    props.setOpenDialog(false)
                  }}
                />
              </IconButton>
            </div>
          )}
        </>
      }
      onRequestClose={() => {
        props.setLoading && props.setLoading(false)
        props.setOpenDialog(false)
      }}
    />
  )
}

export default AuthExtrafieldsDialogComponent
